module.exports = __webpack_public_path__ + "static/media/front_detail.733f26c8.png";